module.exports = __webpack_public_path__ + "static/usloviya_otkrytiya_vklada_fl-f323e7323c2ba6e4d74ced9550e450c8.pdf";